import React from 'react';
import { LinkedinIcon, TwitterIcon, GithubIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#0B1F15] text-white" data-id="element-491">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20" data-id="element-492">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 lg:gap-12" data-id="element-493">
          {/* Logo & tagline */}
          <div className="col-span-2 md:col-span-1" data-id="element-494">
            <img src="https://cdn.magicpatterns.com/uploads/jGYrssm7tbfxt25FxeAxXx/CARBONSAFELOGO.png" alt="CarbonSafe" className="h-8 w-auto brightness-0 invert" data-id="element-495" />
            <p className="mt-4 text-sm text-white/50 leading-relaxed" data-id="element-496">
              Carbon intelligence for a sustainable future.
            </p>
          </div>

          {/* Product */}
          <div data-id="element-497">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-498">
              Product
            </h3>
            <ul className="space-y-3" data-id="element-499">
              <li data-id="element-500">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-501">
                  Emissions Tracking
                </a>
              </li>
              <li data-id="element-502">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-503">
                  Compliance
                </a>
              </li>
              <li data-id="element-504">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-505">
                  Carbon Offsets
                </a>
              </li>
              <li data-id="element-506">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-507">
                  Data Explorer
                </a>
              </li>
              <li data-id="element-508">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-509">
                  API
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-510">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-511">
              Resources
            </h3>
            <ul className="space-y-3" data-id="element-512">
              <li data-id="element-513">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-514">
                  Documentation
                </a>
              </li>
              <li data-id="element-515">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-516">
                  Blog
                </a>
              </li>
              <li data-id="element-517">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-518">
                  Case Studies
                </a>
              </li>
              <li data-id="element-519">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-520">
                  Methodology
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-521">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-522">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-523">
              <li data-id="element-524">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-525">
                  About
                </a>
              </li>
              <li data-id="element-526">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-527">
                  Careers
                </a>
              </li>
              <li data-id="element-528">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-529">
                  Contact
                </a>
              </li>
              <li data-id="element-530">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-531">
                  Partners
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-532">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-533">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-534">
              <li data-id="element-535">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-536">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-537">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-538">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-539">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-540">
                  Cookie Policy
                </a>
              </li>
              <li data-id="element-541">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-542">
                  Security
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-543">
          <p className="text-sm text-white/40" data-id="element-544">
            © 2026 CarbonSafe. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-545">
            <a href="#" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="LinkedIn" data-id="element-546">
              <LinkedinIcon className="w-5 h-5" data-id="element-547" />
            </a>
            <a href="#" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="Twitter" data-id="element-548">
              <TwitterIcon className="w-5 h-5" data-id="element-549" />
            </a>
            <a href="#" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="GitHub" data-id="element-550">
              <GithubIcon className="w-5 h-5" data-id="element-551" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}